import { useEffect } from 'react'

const useWakeLock = () => {
  useEffect(() => {
    let wakeLock: WakeLockSentinel | null = null
    ;(async () => {
      try {
        wakeLock = await navigator.wakeLock.request('screen')
      } catch (e) {
        if (e.name === 'NotAllowedError') {
          console.warn('Wake Lock API not allowed (i.e. iOS WKWebView).')
          return
        }
        console.error(e)
      }
    })()

    return () => {
      wakeLock?.release()
    }
  }, [])
}

export default useWakeLock
